import SessionCache from '@/utils/sessionCache'
import { UserConstants } from '@/models/constant'

export interface UserState {
  token: string
  name: string
  avatar: string
  introduction: string
  roles: string[]
  email: string
}

export const state: UserState = {
  token: SessionCache.getCache(UserConstants.TOKEN) || '',
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  email: '',
}
